import { createContext, useContext } from 'react';

import { ResourceHistoryTarget } from '@/types';

export interface ResourceHistoryContextValue {
    closeResourceHistory: () => void;
    openResourceHistory: (target: ResourceHistoryTarget) => void;
}

export const ResourceHistoryContext = createContext<ResourceHistoryContextValue | undefined>(undefined);

export const useResourceHistory = (): ResourceHistoryContextValue => {
    const context = useContext(ResourceHistoryContext);

    if (!context) {
        throw new Error('useResourceHistory must be used within ResourceHistoryProvider');
    }

    return context;
};
